export const getPageContainerStyles = () => ({
  pageContainer: {
    display: 'flex',
    flex: '1 1 1px',
    flexDirection: 'column',
    overflow: 'auto',
  },

  // Use this pageContainer style for settings pages
  // which need to inherit parent's height, instead of making
  // the parent expand vertically, beyond the available heigh
  // in the viewport, to accomodate the page's contents.
  pageContainerExpandingToParent: {
    display: 'flex',
    flex: '1 1 1px',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
});
